import { flagsFromMe } from '@codex/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { CalendarPage } from '../../calendar/calendar-page.js';

/**
 * `/calendar` (1.O-3 deliverable 4): the campaign's calendar, guarded as `/doc/:id` is. With the
 * `chrono` flag off the page says so and asks for nothing.
 */
export const Route = createFileRoute('/calendar/')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Calendar' },
  component: CalendarRoute,
});

function CalendarRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  return <CalendarPage chrono={flagsFromMe(me).chrono} />;
}
